// extracted by mini-css-extract-plugin
module.exports = {"middle":"styles-module--middle--3iAN5","middleContainer":"styles-module--middleContainer--3Zzt_","middleText":"styles-module--middleText--3ehFA"};